module.exports = __webpack_public_path__ + "img/b3-5.5f88f99.png";